export default "__VITE_PUBLIC_ASSET__1aa6c36b__"